import React from "react";
import PropTypes from 'prop-types';

var TableSort = function TableSort(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 8 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 12 : _ref$height,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12L4.37114e-07 7L8 7L4 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0L8 5L0 5L4 0Z",
    fill: color
  }));
};

TableSort.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string
};
export default TableSort;